import { useConfiguraionContext } from '../../../context/ProviderPage/Configuration';
import { Configuration } from '../../../types/Configuration';
import { formatDate } from '../../../utils/date/formatDate';
import { CustomSwitch } from '../../CustomSwitch';
import { OpenCollectCardContainer, CollectMilkInformation } from './styles';

interface IAppConfigurationProps {
  configuration: Configuration;
  onToggle?: (field: keyof Configuration, value: string) => void;
}

const AppConfiguration = ({
  configuration,
  onToggle,
}: IAppConfigurationProps) => {
  const {
    DFDATASINCRONIZACAO,
    DFIMEI,
    DFDISTRIBUIR,
    DFREGUAFRENTE,
    DFREGUAATRAS,
    DFNOMECARRETEIRO,
    DFLIBERARCOLETA,
    DFTERMOMENTRO,
    DFEXAMESENSORIAL,
    DFEXAMEALIZAROL,
    DFPASSOUNOALIZAROL,
    DFAMOSTRADEQUALIDE,
    DFFOTOSDEAMOSTRA,
    DFFOTOSDATEMPERATURA,
    DFFOTOREGUA1,
    DFFOTOREGUA2,
    DFAMOSTRA,
    DFLACRE,
    DFDIASDEVALIDACAO,
    DFPORCENTAGEMDETOLERANCIA,
    DFATIVARPERCENTUALDELITRAGEM,
  } = configuration;
  const { setEditOneConfiguration, setSelectedConfiguration } =
    useConfiguraionContext();
  const handleToggle = (field: keyof Configuration) => {
    if (onToggle) {
      const currentValue = configuration[field] as string;
      const newValue = currentValue === 'S' ? 'N' : 'S';
      onToggle(field, newValue);
    }
  };

  return (
    <OpenCollectCardContainer>
      <div className="card-title">
        <h1>
          Configuração do Carreteiro {DFNOMECARRETEIRO || 'Não informado'}
        </h1>
      </div>

      <div className="collect-item-row">
        <div className="item-row-medium-with-border">
          <span>
            IMEI: <strong> {DFIMEI || 'Não informado'}</strong>
          </span>
        </div>
        <div className="item-row-medium">
          <span>
            Data Sincronização:{' '}
            <strong>{formatDate(DFDATASINCRONIZACAO)}</strong>
          </span>
        </div>
      </div>

      <div className="collect-item-row">
        <div className="item-row-medium-with-border">
          <span>
            Dias de Validação:{' '}
            <strong>{DFDIASDEVALIDACAO || 'Não informado'}</strong>
          </span>
        </div>
        <div className="item-row-medium">
          <span>
            Tolerância:{' '}
            <strong>
              {DFPORCENTAGEMDETOLERANCIA
                ? `${DFPORCENTAGEMDETOLERANCIA}%`
                : 'Não informado'}
            </strong>
          </span>
        </div>
      </div>

      <CollectMilkInformation meter={0} activeMeter={false}>
        <div className="milk-title-information">
          <span>Configurações de Coleta</span>
        </div>

        <div className="item-row">
          <span>Régua Frontal</span>
          <CustomSwitch
            isOpen={DFREGUAFRENTE === 'S'}
            action={() => handleToggle('DFREGUAFRENTE')}
          />
        </div>

        <div className="item-row">
          <span>Régua Traseira</span>
          <CustomSwitch
            isOpen={DFREGUAATRAS === 'S'}
            action={() => handleToggle('DFREGUAATRAS')}
          />
        </div>

        <div className="item-row">
          <span>Distribuição</span>
          <CustomSwitch
            isOpen={DFDISTRIBUIR === 'S'}
            action={() => handleToggle('DFDISTRIBUIR')}
          />
        </div>

        <div className="item-row">
          <span>Termômetro</span>
          <CustomSwitch
            isOpen={DFTERMOMENTRO === 'S'}
            action={() => handleToggle('DFTERMOMENTRO')}
          />
        </div>

        <div className="item-row">
          <span>Liberar Coleta</span>
          <CustomSwitch
            isOpen={DFLIBERARCOLETA === 'S'}
            action={() => handleToggle('DFLIBERARCOLETA')}
          />
        </div>
      </CollectMilkInformation>

      <CollectMilkInformation
        meter={0}
        activeMeter={false}
        style={{ border: 0 }}
      >
        <div className="milk-title-information">
          <span>Configurações de Qualidade</span>
        </div>

        <div className="item-row">
          <span>Exame Sensorial</span>
          <CustomSwitch
            isOpen={DFEXAMESENSORIAL === 'S'}
            action={() => handleToggle('DFEXAMESENSORIAL')}
          />
        </div>

        <div className="item-row">
          <span>Exame de Alizarol</span>
          <CustomSwitch
            isOpen={DFEXAMEALIZAROL === 'S'}
            action={() => handleToggle('DFEXAMEALIZAROL')}
          />
        </div>

        <div className="item-row">
          <span>Passou no Alizarol</span>
          <CustomSwitch
            isOpen={DFPASSOUNOALIZAROL === 'S'}
            action={() => handleToggle('DFPASSOUNOALIZAROL')}
          />
        </div>

        <div className="item-row">
          <span>Amostra de Qualidade</span>
          <CustomSwitch
            isOpen={DFAMOSTRADEQUALIDE === 'S'}
            action={() => handleToggle('DFAMOSTRADEQUALIDE')}
          />
        </div>
        <div className="item-row">
          <span>Fotos da Amostra</span>
          <CustomSwitch
            isOpen={DFFOTOSDEAMOSTRA === 'S'}
            action={() => handleToggle('DFFOTOSDEAMOSTRA')}
          />
        </div>

        <div className="item-row">
          <span>Fotos da Temperatura</span>
          <CustomSwitch
            isOpen={DFFOTOSDATEMPERATURA === 'S'}
            action={() => handleToggle('DFFOTOSDATEMPERATURA')}
          />
        </div>

        <div className="item-row">
          <span>Fotos da Régua 1</span>
          <CustomSwitch
            isOpen={DFFOTOREGUA1 === 'S'}
            action={() => handleToggle('DFFOTOREGUA1')}
          />
        </div>

        <div className="item-row">
          <span>Fotos da Régua 2</span>
          <CustomSwitch
            isOpen={DFFOTOREGUA2 === 'S'}
            action={() => handleToggle('DFFOTOREGUA2')}
          />
        </div>

        <div className="item-row">
          <span>Amostra</span>
          <CustomSwitch
            isOpen={DFAMOSTRA === 'S'}
            action={() => handleToggle('DFAMOSTRA')}
          />
        </div>

        <div className="item-row">
          <span>Lacre</span>
          <CustomSwitch
            isOpen={DFLACRE === 'S'}
            action={() => handleToggle('DFLACRE')}
          />
        </div>

        <div className="item-row">
          <span>Percentual de Litragem</span>
          <CustomSwitch
            isOpen={DFATIVARPERCENTUALDELITRAGEM === 'S'}
            action={() => handleToggle('DFATIVARPERCENTUALDELITRAGEM')}
          />
        </div>
      </CollectMilkInformation>
      <div className="card-footer">
        <button
          className="edit-configuration"
          onClick={() => {
            setEditOneConfiguration(true);
            setSelectedConfiguration(configuration);
          }}
        >
          Editar
        </button>
      </div>
    </OpenCollectCardContainer>
  );
};

export { AppConfiguration };
